// extracted by mini-css-extract-plugin
module.exports =  {"tc-radar-chart":"RadarChart-module__tc-radar-chart___PHAQm","tc-radar-chart-label--selected":"RadarChart-module__tc-radar-chart-label--selected___dOOyi"};